module.exports = __webpack_public_path__ + "img/goldregen-2020-058.a98b5459.jpg";